if (!customElements.get("example-section")) {
  customElements.define(
    "example-section",
    class ExampleSection extends HTMLElement {
      dataEl;
      data;
      constructor() {
        super();
        this.dataEl = this.querySelector("[data-section-data]");
        this.data = this.dataEl?.textContent ? JSON.parse(this.dataEl.textContent) : {};
      }
      logData() {
        console.log(this.data);
      }
      init() {
        this.logData();
      }
      // Lifecycle callback when the element is connected to the DOM
      connectedCallback() {
        this.init();
      }
    }
  );
}
